import { Menu } from 'antd';
import styled from 'styled-components';

const { SubMenu } = Menu;

export const Styledsubmenu = styled(SubMenu)`
  float: right;
`;

export const GlobalHeader = styled.div`
  position:realtive;
  display:flex;
  align-items:center;
  height:100%;
  box-shadow: 0 1px 4px rgba(26, 54, 82, 0.1);
  background-color: ${(props) => props.background};
  color: ${(props) => props.text};
  border-bottom: 1px solid rgba(0, 0, 0, 0.32);
`;

export const GlobalHeaderLogo = styled.div`
  position: relative;
  overflow: hidden;
   margin-top: 18px;
`;